export default __webpack_public_path__ + "static/banner-5-restaurants-you-can-visit-with-your-infinity-rewards-6367d85783bc5aeb836cf65df8210407.jpg";